import { render, staticRenderFns } from "./ControleIndividual.vue?vue&type=template&id=8ee8a9ba&scoped=true&"
import script from "./ControleIndividual.vue?vue&type=script&lang=js&"
export * from "./ControleIndividual.vue?vue&type=script&lang=js&"
import style0 from "./ControleIndividual.vue?vue&type=style&index=0&id=8ee8a9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee8a9ba",
  null
  
)

export default component.exports